import { isProd } from './environment';

export const isTariffComparatorDemo = () => !isProd && !!localStorage.getItem('tariffComparator');
export const isDemoPushNotifications = () => !isProd && !!localStorage.getItem('demoPushNotifications');
export const isEcoTileDemo = () => !isProd && !!localStorage.getItem('ecoTile');
export const isEcoPointsDemo = () => !isProd && !!localStorage.getItem('ecoPoints');
export const isNewMeterDemo = () => !isProd && !!localStorage.getItem('newMeter');
